import React from 'react';
import { useAppSelector } from 'store/hooks';

import { lessonsSelector } from 'store/lessons/selectors';

import { DefaultModal } from 'components/DefaultModal';

import { useLessons } from './CatalogLessonsPage.hooks';

import CatalogLessonsPage from './CatalogLessonsPage';

const CatalogLessonsPageContainer = () => {
  const lessons = useAppSelector(lessonsSelector);

  const {
    loading,
    removeConfirmOpen,
    removeConfirmData,
    closeRemoveConfirm,
    onLessonRowClick,
    onLessonEditClick,
    onLessonRemoveClick,
    onConfirmRemoveClick,
    onLessonCreateClick,
  } = useLessons();

  return (
    <>
      <CatalogLessonsPage
        loading={loading}
        lessons={lessons}
        onLessonRowClick={onLessonRowClick}
        onLessonEditClick={onLessonEditClick}
        onLessonRemoveClick={onLessonRemoveClick}
        onLessonCreateClick={onLessonCreateClick}
      />
      <DefaultModal
        {...removeConfirmData}
        open={removeConfirmOpen}
        confirmText="Yes, remove"
        onConfirmClick={onConfirmRemoveClick}
        onCancelClick={closeRemoveConfirm}
        onClose={closeRemoveConfirm}
      />
    </>
  );
};

export default CatalogLessonsPageContainer;
